export const Logo = ({ size = 88 }) => (
  <svg viewBox="0 0 96 96" width={size} height={size} aria-label="Stock Rodeo logo" role="img">
    <defs>
      <linearGradient id="srBg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#3a2618" />
        <stop offset="1" stopColor="#140d09" />
      </linearGradient>
      <linearGradient id="srHat" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#e9c46a" />
        <stop offset="1" stopColor="#b3841f" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="92" height="92" rx="22" fill="url(#srBg)" stroke="#d4a937" strokeOpacity="0.55" strokeWidth="2" />
    <rect x="8" y="8" width="80" height="80" rx="17" fill="none" stroke="#d4a937" strokeOpacity="0.18" strokeDasharray="3 4" />
    <path d="M34 40 C34 24 40 20 48 26 C56 20 62 24 62 40 Z" fill="url(#srHat)" />
    <rect x="34" y="36" width="28" height="4" fill="#5c3512" />
    <path d="M16 42 C24 50 72 50 80 42 C76 48 66 52 48 52 C30 52 20 48 16 42 Z" fill="url(#srHat)" />
    <polyline points="18,78 34,68 46,72 62,58 78,62" fill="none" stroke="#7fb55a" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="78" cy="62" r="4" fill="#7fb55a" />
  </svg>
);

export const BrandMark = () => (
  <div className="brand-mark" data-testid="header-brand">
    <Logo size={38} />
    <span className="brand-word">Stock Rodeo</span>
  </div>
);
